import { onMessage } from "firebase/messaging";
import axios from "axios";
import { messaging, requestForToken } from "./firebase";
import { createRoot } from "react-dom/client";
import NotificationManager from "../Component/Notification/NotificationManager";
import React from "react";

let notificationContainer = null;
let notificationRoot = null;
let notifications = [];

const renderNotifications = () => {
  if (!notificationContainer) {
    notificationContainer = document.createElement('div');
    document.body.appendChild(notificationContainer);
    notificationRoot = createRoot(notificationContainer);
  }

  const handleClose = (id) => {
    notifications = notifications.filter(n => n.id !== id);
    renderNotifications();
  };

  notificationRoot.render(
    <NotificationManager
      notifications={notifications}
      onClose={handleClose}
    />
  );
};

const showNotificationPopup = (title, body, image) => {
  const notification = {
    id: Date.now() + Math.random(),
    title,
    body,
    image
  };
  
  notifications.push(notification);
  renderNotifications();
};

export const initializeNotifications = () => {
  // Handle foreground notifications
  onMessage(messaging, (payload) => {
    console.log(payload);
    showNotificationPopup(
      payload.notification.title,
      payload.notification.body,
      payload.notification.image
    );
  });

  // Register service worker
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then(() => console.log("✅ Firebase messaging service worker registered"))
      .catch((err) => console.error("❌ Service worker registration failed:", err));
  }

  // Initial render
  renderNotifications();
};

export const registerFCMToken = async (endpoint) => {
  const token = await requestForToken();
  if (token) {
    await axios.patch(endpoint, { token });
    localStorage.setItem("admin_fcm_token", token);
    console.log("✅ FCM token saved");
  }
};

export const requestNotificationPermission = async (endpoint) => {
  if (Notification.permission === "default") {
    const result = await Notification.requestPermission();
    
    if (result === "granted") {
      console.log("✅ Notifications allowed");
      await registerFCMToken(endpoint);
    } else {
      console.warn("❌ Notifications blocked");
    }
  } else if (Notification.permission === "granted") {
    await registerFCMToken(endpoint);
  }
};
